import { Component, OnInit } from '@angular/core';
import { DataStoreService } from '../data-store.service';

@Component({
  selector: 'app-form-page',
  templateUrl: './form-page.component.html',
  styleUrls: ['./form-page.component.scss']
})
export class FormPageComponent implements OnInit {

  public emailText: string;

  constructor( public dataStore: DataStoreService) { }

  ngOnInit() {

    this.emailText = this.dataStore.emailText;
    window.scrollTo(0,0);

  }

}
